/* eslint-disable import/prefer-default-export */
import times from 'lodash.times';
import cloneDeep from 'lodash.clonedeep';

export const TYPES = {
  CREATE_INPUT: 'create_input',
  DELETE_INPUT: 'delete_input',
  SELECT_TAG: 'select_tag',
  EDIT_VALUE: 'edit_value'
};

export function updateMetaState(state) {
  return {
    ...state,
    numberOfInputs: state.inputs.length,
    arrayIndexes: state.inputs.length - 1
  };
}

export function createInitialState({ minInputs }) {
  const inputs = times(minInputs, () => '');

  return updateMetaState({ inputs });
}

export function reducer(state, action) {
  switch (action.type) {
    case TYPES.CREATE_INPUT: {
      const { inputs } = state;

      const nextInput = [...inputs, ''];

      return updateMetaState({ ...state, inputs: nextInput });
    }
    case TYPES.DELETE_INPUT: {
      const { inputs } = state;
      const { arrayIndexes } = action.payload;
      const nextInputs = inputs.filter((_, i) => arrayIndexes !== i);

      return updateMetaState({ ...state, inputs: nextInputs });
    }
    case TYPES.SELECT_TAG: {
      const nextState = cloneDeep(state);
      const { inputs } = nextState;

      const { tag } = action.payload;
      const foundElement = inputs.find(inputValue => inputValue === tag);

      if (foundElement) {
        nextState.inputs = inputs.filter(input => input !== tag).concat('');
      } else {
        inputs.some((value, index) => {
          const isLastElementOfArray = index === nextState.inputs.length - 1;
          if (!value) {
            nextState.inputs[index] = tag;
            return true;
          }

          if (value && isLastElementOfArray) {
            nextState.inputs.push(tag);
          }
          return false;
        });
      }

      return updateMetaState(nextState);
    }

    case TYPES.EDIT_VALUE: {
      const nextState = cloneDeep(state);

      const { inputs } = nextState;
      const { index, value } = action.payload;

      inputs[index] = value;

      return updateMetaState(nextState);
    }

    default: {
      throw new Error('Not valid action');
    }
  }
}
